class FilePlayer {
    constructor(video_id){
        //console.log('Player:File');
        this.player = null;
        this.video_id = video_id;
        this.options = {
            showinfo: false,
            controls: true
        };
        this.events = {
            unMute:false,
            mute:false,
            play:false,
            stop:false
        };
        this.is_ready = false;
    }

    ready (){
        this.is_ready = true;
        Object.keys(this.events).map((event) => {
            //console.log('Event:', event, this.events[event]);
            if(this.events[event] === true){
                this[event]();
            }
        });
    }

    showTitle(status = true){
        this.options.showinfo = status;
        return this;
    }

    showControls(status = true){
        //console.log('FilePlayer:showControls:', this.player);
        this.options.controls = status;
        return this;
    }

    mute(){
        if(!this.is_ready){
            this.events.mute = true;
            return this;
        }
        //console.log('FilePlayer:mute:', this.player);
        this.player.muted = true;
        return this;
    }

    unMute(){
        if(!this.is_ready){
            this.events.unMute = true;
            return this;
        }
        //console.log('FilePlayer:unmute:', this.player);
        this.player.muted = false;
        return this;
    }

    play(){
        if(!this.is_ready){
            this.events.play = true;
            return this;
        }
        //console.log('FilePlayer:play');
        this.player.play();
        return this;
    }

    stop(){
        if(!this.is_ready){
            this.events.play = true;
            return this;
        }
        //console.log('FilePlayer:stop');
        this.player.pause();
        this.player.currentTime = 0;
        this.player.remove();
        return this;
    }

    source(source){
        let content = document.getElementById(this.video_id);
        this.player = document.createElement('video');
        this.player.id = this.video_id + '_iframe';
        this.player.style.width = '100%';
        this.player.style.height = '100%';

        this.player.src = source;

        Object.keys(this.options).map((key, index) => {
            this.player[key] = this.options[key];
        });
        
        content.appendChild(this.player);
        content.style.width = '100%';
        content.style.height = '100%';

        //console.log('File:init');
        this.player.addEventListener('loadeddata', (event) => {
            //console.log('File:loadeddata');
            this.ready();
        });
        return this;
    }
}

export default FilePlayer;